module.exports = __webpack_public_path__ + "static/media/mls@2x.fc773e2f.png";